<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" class="pt-1">
          <header-sidebar></header-sidebar>
          <v-card class="table-content elevation-0" style="background: transparent;">
            <v-card-title>
              <b>Base de donnéees</b>
            </v-card-title>
            <v-item-group mandatory active-class="button-database-active" v-model="group" class="ml-3 mr-3">
                <v-row>
                    <v-col
                    v-for="row in database"
                    @click="changeCurrentComponent(row)"
                    :key="row.title"
                    cols="12"
                    sm="3"
                    >
                    <v-item v-slot:default="{ toggle }">
                        <v-card
                        class="d-flex align-center button-database"
                        @click="toggle"
                        >
                           <div
                            class="flex-grow-1 text-center"
                            >
                             {{row.title}}
                            </div>
                        </v-card>
                    </v-item>
                    </v-col>
                </v-row>
            </v-item-group>
          </v-card>

          <v-card class="table-content" v-if="currentComponent">
            <!--<v-card-title>
              {{currentComponentTitle}}
            </v-card-title>-->
            <component :permissions="permissions" :is="currentComponent"></component>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</v-layout>
</template>

<script>
import headerSidebar from '../commons/header_sidebar.component'
import manageAgents from './agent/listing'
import manageNavires from './navire/listing'
import managePorts from './port/listing'
import manageArmateurs from './armateur/listing'
import manageConteneurs from './conteneur/listing'
import manageConsigs from './consig/listing'
import manageCorrespondants from './correspondant/listing'
import managePrestations from './prestation/listing'

export default {
  name: 'Dashboard-Database',
  components: {headerSidebar, manageAgents, manageNavires, managePorts, manageArmateurs, manageConteneurs, manageConsigs, manageCorrespondants, managePrestations},
  data: () => ({
    drawer: true,
    currentManagement: {title: 'Tous'},
    mini: false,
    search: '',
    expanded: [],
    drawerClass: '',
    row: 'import',
    group: {},
    dialog: false,
    database: [
      {title: 'Navires', path:{name : 'databaseNavire'}, titre: 'Gestion des Navires', componentName: 'manage-navires'},
      {title: 'Ports', path:{name : 'databasePort'}, titre: 'Gestion des Ports' , componentName: 'manage-ports'},
      {title: 'Conteneurs', path:{name: 'databaseConteneur'}, titre: 'Gestion des Conteneurs' , componentName: 'manage-conteneurs'},
      {title: 'Armateurs', path:{name: 'databaseArmateur'}, titre: 'Gestion des Armateurs' , componentName: 'manage-armateurs'},
      {title: 'Consignataires', path : {name : 'databaseConsig'}, titre: 'Gestion des Consignataires' , componentName: 'manage-consigs'},
      {title: 'Correspondants', path:{name : 'databaseCorrespondant'}, titre: 'Gestion des Correspondants' , componentName: 'manage-correspondants'},
      {title: 'Préstations & Fret', path:{name: 'databasePrestation'}, titre: 'Gestion des Préstations & Fret' , componentName: 'manage-prestations'},
      {title: 'Agents', path:{name : 'databaseAgent'}, titre: 'Gestion des Aegnts' , componentName: 'manage-agents'}
    ],
    currentComponent: 'manage-navires',
    currentComponentTitle: 'Gestion des Navires',
  }),
  props: ['permissions'],
  mounted(){
    if(this.$route.query){
      var query = this.$route.query
      if(query.table){
        console.log(query.table)
        this.database.forEach((item, key) => {
          if(item.componentName === query.table){
            console.log(item.componentName)
            this.changeCurrentComponent(item)
            this.group = key
          }
        })
      }
      
    }
  },
  methods : {
    changeCurrentComponent(component){
      this.currentComponent = component.componentName
      this.currentComponentTitle = component.titre
      if(this.$router.currentRoute.query){
        if(this.$router.currentRoute.query.table !== this.currentComponent){
          this.$router.replace({path: this.$router.currentRoute.path, query: {table: component.componentName}}).catch(error => { console.info(error)})
        }
      }
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .button-database-active{
    background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%) !important; 
    color: white !important;
  }
  .button-database{
    height: 60px;
    background: white;
    color: black;
    border-radius: 15px;
  }
  .filter-selectbox{
    margin-left: 16px;
    width: 63%;
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  .main-toolbar {
    background: transparent !important;
    .back-dashboard {
      font-size: 12px;
      color: #9ca8b4;
      letter-spacing: 0.02em;
      text-transform: none;
      font-weight: 700;
      .v-icon {
        font-size: 14px;
      }
    }
    .right-btn-group .v-btn {
      margin-left:10px;
      box-shadow: 0px 1px 0px rgba(0,0,0,0.1);
      background: white !important;
      padding: 20px 10px;
      text-transform: none;
      letter-spacing: 0.01em;
      color: #46545c;
      font-size: 12px;
      font-weight: 700;
      &.success {
        background: #70cd0d !important;
        color: white;
      }
      span {
        max-width: 175px;
      }
    }
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table td, .v-data-table th{
    padding: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/database/listing.vue